import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KnScheduler = _resolveComponent("KnScheduler")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_t = _resolveDirective("t")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary schedulerDialog",
    visible: _ctx.visibility,
    footer: "footer",
    header: _ctx.$t('workspace.myData.monitoring'),
    modal: "",
    breakpoints: { '960px': '75vw', '640px': '100vw' },
    closable: false,
    baseZIndex: 1,
    autoZIndex: true
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        visible: _ctx.visibility,
        class: "kn-button--secondary",
        label: _ctx.$t('common.cancel'),
        onClick: _ctx.cancel
      }, null, 8, ["visible", "label", "onClick"]),
      _withDirectives(_createVNode(_component_Button, {
        visible: _ctx.visibility,
        class: "kn-button--primary",
        onClick: _ctx.saveSchedulation,
        disabled: !_ctx.touched
      }, null, 8, ["visible", "onClick", "disabled"]), [
        [_directive_t, 'common.save']
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_KnScheduler, {
        class: "p-m-1",
        cronExpression: _ctx.currentCronExpression,
        cronExpressionType: _ctx.cronExpressionType,
        descriptor: _ctx.schedulerDescriptor,
        onTouched: _cache[1] || (_cache[1] = ($event: any) => (_ctx.touched = true)),
        readOnly: false,
        logs: _ctx.logs,
        schedulationEnabled: _ctx.schedulationEnabled,
        schedulationPaused: _ctx.schedulationPaused,
        "onUpdate:schedulationPaused": _ctx.updateSchedulationPaused,
        "onUpdate:schedulationEnabled": _ctx.updateSchedulationEnabled,
        "onUpdate:currentCronExpression": _ctx.updateCurrentCronExpression,
        "onUpdate:cronExpressionType": _ctx.updateCronExpressionType,
        loadingLogs: _ctx.loadingLogs
      }, null, 8, ["cronExpression", "cronExpressionType", "descriptor", "logs", "schedulationEnabled", "schedulationPaused", "onUpdate:schedulationPaused", "onUpdate:schedulationEnabled", "onUpdate:currentCronExpression", "onUpdate:cronExpressionType", "loadingLogs"])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}